import { render, staticRenderFns } from "./batchModel.vue?vue&type=template&id=31e21b9a&scoped=true&"
import script from "./batchModel.vue?vue&type=script&lang=js&"
export * from "./batchModel.vue?vue&type=script&lang=js&"
import style0 from "./batchModel.vue?vue&type=style&index=0&id=31e21b9a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e21b9a",
  null
  
)

export default component.exports